import { AllFormationSessionsResponse } from '../../../types/api/endpoints/formations/allFormationSessions.types';
import { FORMATIONS_ENDPOINTS } from '../../../utils/api/endpoints/formationsEndpoints';

const PREFIX = '[allFormationSessionsQuery]';

export const queryAllformationSessions = async () => {
  console.log(PREFIX, `Fetching all formation sessions...`);
  const response = await FORMATIONS_ENDPOINTS.all();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all formation sessions.`);
  return json as AllFormationSessionsResponse;
};
